import { createMuiTheme } from "@material-ui/core";
import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";

const AppTheme = createMuiTheme({
  overrides: {
    MuiSwitch: {
      colorSecondary: {
        "&$checked": {
          color: "#1EA3F8"
        },
        "&$checked + $track": {
          backgroundColor: "#1EA3F8"
        }
      }
    },
    MuiRadio: {
      colorSecondary: {
        "&$checked": {
          color: "#1EA3F8"
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        "&$checked": {
          color: "#1EA3F8"
        }
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: 14
      }
    },
    MuiInputBase: {
      input: {
        fontSize: 14
      }
    },
    MuiButton: {
      root: {},
      label: {
        fontSize: 14
      },
      contained: {
        height: 50
      },
      containedPrimary: {
        color: "#fff"
      },
      outlined: {
        height: 50,
        borderWidth: 2,
        "&:hover": {
          borderWidth: 2
        }
      },
      outlinedPrimary: {
        borderWidth: 2,
        "&:hover": {
          borderWidth: 2
        }
      },
      outlinedSecondary: {
        borderWidth: 2,
        "&:hover": {
          borderWidth: 2
        }
      }
    },
    MuiChip: {
      colorPrimary: {
        color: "#fff"
      }
    }
  },
  palette: {
    primary: {
      main: "#1EA3F8"
    },
    secondary: {
      main: "#1EA3F8"
    }
  },
  status: {
    danger: "orange"
  },
  typography: {
    fontFamily: ["Ubuntu", "sans-serif"].join(","),
    body1: {
      color: "#222223"
    }
  }
} as ThemeOptions);

export default AppTheme;
